import { t } from '@lingui/macro'
import { types } from 'mobx-state-tree'

import { appConfig } from '../config'
import { i18n } from '../i18n'
import { BaseModel } from '../models/BaseModel'

export const UserModel = BaseModel.named('User')
  .props({
    name: types.maybeNull(types.string),
    language: types.optional(types.string, appConfig.fallbackLanguage),
  })
  .views(self => ({
    get displayName() {
      return self.name || i18n._(t`Unknown user`)
    },
  }))
  .actions(self => ({
    setName(name: Maybe<string>) {
      self.name = name
    },
    afterAttach() {
      if (self.auth.onAuthStateChanged) {
        self.auth.onAuthStateChanged(async user => {
          if (user) {
            this.setName(user.displayName || user.email)
          } else {
            this.setName(null)
          }
        })
      }
    },
  }))

export type TUserModel = typeof UserModel.Type
